import * as React from "react";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import User from "../../../model/user/User";
import {none, option} from "ts-option";
import AgentSelector from "../../lead/v4/agentSelector/AgentSelector";

type Props = FormGroupProps<string> & PlaceholderProps;

/**
 * Account manager selector form view group.
 */
export default class AMSelectorFormGroup extends React.PureComponent <Props, {}> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<AgentSelector
					customRoleTitle={"AM"}
					agentId={this.props.field.getOptionalValue()}
					removable={this.props.field.getOptionalValue().isDefined}
					onRemoveClick={this.onRemove}
					onChange={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Remove selection
	 */
	onRemove = () => {
		this.props.onChange(this.props.field.updateValue(none))
	};
	/**
	 * Callback on account manager (agent) changed.
	 * @param user
	 */
	onChange = (user: User) => {
		this.props.onChange(this.props.field.updateValue(option(user.id)));
	}
}